import { render } from "./LebihTahun.vue?vue&type=template&id=3afe04f8"
import script from "./LebihTahun.vue?vue&type=script&lang=js"
export * from "./LebihTahun.vue?vue&type=script&lang=js"

import "./LebihTahun.vue?vue&type=style&index=0&id=3afe04f8&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__